import { render, staticRenderFns } from "./ScanFormDPTable.vue?vue&type=template&id=2c8c8960&scoped=true"
import script from "./ScanFormDPTable.vue?vue&type=script&lang=js"
export * from "./ScanFormDPTable.vue?vue&type=script&lang=js"
import style0 from "./ScanFormDPTable.vue?vue&type=style&index=0&id=2c8c8960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c8960",
  null
  
)

export default component.exports